"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("el-form", {
    ref: "clientFormRef",
    staticClass: "demo-form",
    attrs: {
      model: _vm.clientData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.clientData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.clientData, "enabled", $$v);
      },
      expression: "clientData.enabled"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Name",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      name: "name",
      required: "",
      placeholder: "Name",
      maxlength: "150",
      minlength: "3",
      "show-word-limit": ""
    },
    model: {
      value: _vm.clientData.name,
      callback: function ($$v) {
        _vm.$set(_vm.clientData, "name", $$v);
      },
      expression: "clientData.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Email",
      prop: "emailAddress"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Email",
      name: "emailAddress"
    },
    model: {
      value: _vm.clientData.emailAddress,
      callback: function ($$v) {
        _vm.$set(_vm.clientData, "emailAddress", $$v);
      },
      expression: "clientData.emailAddress"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Company",
      prop: "companyId"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      placeholder: "Select Company"
    },
    model: {
      value: _vm.clientData.companyId,
      callback: function ($$v) {
        _vm.$set(_vm.clientData, "companyId", $$v);
      },
      expression: "clientData.companyId"
    }
  }, _vm._l(_vm.companiesList, function (company) {
    return _c("el-option", {
      key: company.id,
      attrs: {
        label: company.name,
        value: company.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Contact Number",
      prop: "contactNumber"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Contact Number",
      name: "contactNumber"
    },
    model: {
      value: _vm.clientData.contactNumber,
      callback: function ($$v) {
        _vm.$set(_vm.clientData, "contactNumber", $$v);
      },
      expression: "clientData.contactNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Logo"
    }
  }, [_c("div", {
    staticClass: "icon-upload-wrapper"
  }, [_vm.formData.logo ? _c("div", {
    staticClass: "icon-preview"
  }, [_c("img", {
    attrs: {
      src: _vm.formData.logo
    }
  }), _c("div", {
    staticClass: "overlay"
  }, [_c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.formData.logo = "";
      }
    }
  }, [_vm._v(" Change ")])], 1)]) : _c("div", {
    staticClass: "upload-box",
    on: {
      click: _vm.triggerFileInput
    }
  }, [_c("i", {
    staticClass: "el-icon-plus upload-icon"
  }), _c("p", [_vm._v("Click to upload icon")]), _c("small", [_vm._v("PNG / JPG (1:1 ratio)")]), _c("input", {
    ref: "fileInput",
    attrs: {
      type: "file",
      accept: ".jpg,.jpeg,.png",
      hidden: ""
    },
    on: {
      change: _vm.onFileSelected
    }
  })])])]), _c("el-dialog", {
    attrs: {
      visible: _vm.cropperVisible,
      width: "420px",
      "custom-class": "cropper-dialog"
    },
    on: {
      "update:visible": function ($event) {
        _vm.cropperVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "cropper-wrapper"
  }, [_c("cropper", {
    ref: "cropper",
    attrs: {
      src: _vm.imageSrc,
      "stencil-props": {
        aspectRatio: 1
      }
    }
  })], 1), _c("span", {
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.cropperVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.cropImage
    }
  }, [_vm._v(" Crop & Upload ")])], 1)]), _c("el-form-item", {
    attrs: {
      label: "Industries",
      prop: "industriesId"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      placeholder: "Select Type"
    },
    model: {
      value: _vm.clientData.industriesId,
      callback: function ($$v) {
        _vm.$set(_vm.clientData, "industriesId", $$v);
      },
      expression: "clientData.industriesId"
    }
  }, _vm._l(_vm.industriesList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Website",
      prop: "website"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Website"
    },
    model: {
      value: _vm.clientData.website,
      callback: function ($$v) {
        _vm.$set(_vm.clientData, "website", $$v);
      },
      expression: "clientData.website"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Payment Terms",
      prop: "paymentTerms"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      placeholder: "Payment Terms",
      rows: 3
    },
    model: {
      value: _vm.clientData.paymentTerms,
      callback: function ($$v) {
        _vm.$set(_vm.clientData, "paymentTerms", $$v);
      },
      expression: "clientData.paymentTerms"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      loading: _vm.loading,
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")])], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;